import React from 'react';
import { useOnline } from '../hooks/useOnline';
import { CloudSlash, CloudCheck } from '@phosphor-icons/react';

export default function OfflineBadge({ className = '' }) {
  const online = useOnline();
  return (
    <div
      data-testid="offline-indicator"
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wider ${
        online
          ? 'bg-emerald-500/10 text-emerald-400 border border-emerald-500/30'
          : 'bg-zinc-500/15 text-zinc-300 border border-zinc-500/40'
      } ${className}`}
    >
      {online ? <CloudCheck size={12} weight="bold" /> : <CloudSlash size={12} weight="bold" />}
      {online ? 'ONLINE' : 'OFFLINE MODE'}
    </div>
  );
}
